/*
*
* File JS per la ESG Page
*
*/

// IMPORT COMPONENTI
//--------------------------------------------------------------------//
import 'swiper/css/bundle';
import Swiper from 'swiper/core';

import heroSimple from 'components/hero-simple/hero-simple';
import breadcrumbs from 'components/breadcrumbs/breadcrumbs';
import contentBlocks from 'components/content-blocks/content-blocks';
import blockMagazine from 'components/block-magazine/block-magazine';
import cardMagazine from 'components/card-magazine/card-magazine';

//--------------------------------------------------------------------//

// IMPORT STILE SPECIFICO PAGINA
//--------------------------------------------------------------------//

import './esg.scss';

//--------------------------------------------------------------------//

// INIT COMPONENTI
//--------------------------------------------------------------------//

contentBlocks();
blockMagazine();
cardMagazine();

function isInViewport(elem)
{
    if (jQuery(elem).length === 0) {
        return false
    }
    let elementTop = jQuery(elem).offset().top;
    let elementBottom = elementTop + jQuery(elem).outerHeight();
    let viewportTop = jQuery(window).scrollTop();
    let viewportBottom = viewportTop + jQuery(window).height();
    return elementBottom > viewportTop && elementTop < viewportBottom && jQuery(elem).is(':visible');
}

function esgNavigation()
{
    let isMobile = false;
    let viewPortWidth = Math.round(window.innerWidth);
    // device detection
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        isMobile = true;
    }
    // viewport detection
    if (viewPortWidth <= 1148) {
        isMobile = true;
    }

    let sectionE = document.querySelector('.esg_sections .wrapper_block #esg_block_1');
    let sectionS = document.querySelector('.esg_sections .wrapper_block #esg_block_2');
    let sectionG = document.querySelector('.esg_sections .wrapper_block #esg_block_3');
    let end = document.querySelector('.after_esg_sections #after_esg_block_0');
    let navigation = document.querySelector('.esg_navigation');
    let boundingNav = navigation.getBoundingClientRect();
    let boundingEnd = end.getBoundingClientRect();
    let boundingSectionE = sectionE.getBoundingClientRect();
    let boundingSectionS = sectionS.getBoundingClientRect();
    let boundingSectionG = sectionG.getBoundingClientRect();

    const scrollEvents = function ()
    {
        //console.log('init boundingNav', boundingNav.top);
        let body = document.getElementsByTagName('body');
        let detectScrollUp = body[0].classList.contains('scroll-up');
        let detectScrollDown = body[0].classList.contains('scroll-down');
        let navE = document.querySelector('.esg_navigation .esg_navigation__wrapper .letters .e');
        let navS = document.querySelector('.esg_navigation .esg_navigation__wrapper .letters .s');
        let navG = document.querySelector('.esg_navigation .esg_navigation__wrapper .letters .g');
        let linkE = document.querySelector('.esg_navigation .esg_navigation__wrapper .links .e');
        let linkS = document.querySelector('.esg_navigation .esg_navigation__wrapper .links .s');
        let linkG = document.querySelector('.esg_navigation .esg_navigation__wrapper .links .g');
        let nav = document.querySelector('.esg_navigation .esg_navigation__wrapper');

        boundingNav = navigation.getBoundingClientRect();
        boundingEnd = end.getBoundingClientRect();
        boundingSectionE = sectionE.getBoundingClientRect();
        boundingSectionS = sectionS.getBoundingClientRect();
        boundingSectionG = sectionG.getBoundingClientRect();

        if (detectScrollDown) {
            // Scroll DOWN
            if (boundingSectionS.top <= 250 && !navS.classList.contains('active') && !navG.classList.contains('active')) {
                // Active S
                navS.classList.add('active');
                linkS.classList.add('active');
                // remove active
                navE.classList.remove('active');
                navG.classList.remove('active');
                linkE.classList.remove('active');
                linkG.classList.remove('active');
            } else if (boundingSectionG.top <= 250 && !navG.classList.contains('active')) {
                // Active G
                navG.classList.add('active');
                linkG.classList.add('active');
                // remove active
                navE.classList.remove('active');
                navS.classList.remove('active');
                linkE.classList.remove('active');
                linkS.classList.remove('active');
            }
        }

        if (detectScrollUp) {
            // Scroll UP
            if (boundingSectionS.bottom >= 250 && navG.classList.contains('active') && !navS.classList.contains('active')) {
                // Active S
                navS.classList.add('active');
                linkS.classList.add('active');
                // remove active
                navE.classList.remove('active');
                navG.classList.remove('active');
                linkE.classList.remove('active');
                linkG.classList.remove('active');
            } else if (boundingSectionE.bottom >= 250 && navS.classList.contains('active') && !navE.classList.contains('active')) {
                // Active E
                navE.classList.add('active');
                linkE.classList.add('active');
                // remove active
                navS.classList.remove('active');
                navG.classList.remove('active');
                linkS.classList.remove('active');
                linkG.classList.remove('active');
            }
        }

        //console.log('mobile',isMobile, 'boundingNav',boundingNav.top);

        // Sticky Navigation
        if (!isMobile) {
            if (detectScrollDown && boundingNav.top < 0) {
                nav.classList.add('sticky');
            } else if (detectScrollUp && boundingNav.top >= 0) {
                nav.classList.remove('sticky');
            }
        } else {
            //console.log('mobile nav top', boundingNav.top);
            if (boundingNav.top <= 0) {
                nav.classList.add('sticky');
            } else if (boundingNav.top >= 120) {
                nav.classList.remove('sticky');
            }
        }

        // Only desktop
        if (!isMobile) {
            if (boundingEnd.top <= 0) {
                nav.classList.remove('sticky');
            } else if (detectScrollUp && boundingEnd.top >= 0 && boundingNav.top <= 0) {
                nav.classList.add('sticky');
            }
        }
    }
    scrollEvents();

    window.addEventListener('scroll', scrollEvents, false);
}

function smoothScroll()
{
    jQuery('a[href*="#"]:not([href="#"])').on('click', function (event) {
        let offset = 30;
        if (this.getAttribute('href')) {
            let href = this.getAttribute('href');
            href = href.replaceAll('/', '');
            let target = $(href);
            console.log(target);
            if (0 !== target.length) {
                event.preventDefault();
                event.stopImmediatePropagation();
                $("html,body").stop().animate({
                    scrollTop: (target.offset().top - offset),
                    easing: 'easeInOutQuad',
                }, 1000);
            }
        }
    });
}

function esgSlider() {
    let esgSlider = document.querySelector('.block-text-cards-text__wrap .swiper-container');
    if (esgSlider) {
        let args = {
            slidesPerView: "auto",
            spaceBetween: 0,
            loop: false,
            a11y: {
                enabled: true,
                prevSlideMessage: 'Previous slide',
                nextSlideMessage: 'Next slide',
                firstSlideMessage: 'This is the first slide',
                lastSlideMessage: 'This is the last slide',
                paginationBulletMessage: 'Go to slide {{index}}',
                notificationClass: 'swiper-notification'
            },
        };
        new Swiper(esgSlider, args);
    }
}
function magazineEsgSlider() {
    let magazineEsgSlider = document.querySelector('.block-magazine__list-inner .swiper-container');
    console.log(magazineEsgSlider);
    if (magazineEsgSlider) {
        let args = {
            slidesPerView: 'auto',
            spaceBetween: 0,
            centeredSlides: true,
            loop: true,
            a11y: {
                enabled: true,
                prevSlideMessage: 'Previous slide',
                nextSlideMessage: 'Next slide',
                firstSlideMessage: 'This is the first slide',
                lastSlideMessage: 'This is the last slide',
                paginationBulletMessage: 'Go to slide {{index}}',
                notificationClass: 'swiper-notification'
            },
            breakpoints: {
                640: {
                    slidesPerView: 2,
                },
                768: {
                    slidesPerView: 2,
                },
                1024: {
                    slidesPerView: 3,
                },
            },
        };
        new Swiper(magazineEsgSlider, args);
    }
}

smoothScroll();
esgNavigation();
esgSlider();
magazineEsgSlider();

//--------------------------------------------------------------------//